export const LABELS = {
  // Actions Labels
  CREATE: 'Create',
  UPDATE: 'Update',
  VIEW: 'View',
  DELETE: 'Delete',
  SEARCH: 'Search',
  APPLY: 'Apply',
  RESET: 'Reset',
  ACTIONS: 'Actions',
  YES: 'Yes',
  NO: 'No',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  NO_PERM: 'No Permissions',
  PROCESS: 'Process',
  GENERATE: 'Generate',

  // Dynamic Action Labels
  CREATE_ACTION: (action: string) => `Create ${action}`,
  UPDATE_ACTION: (action: string) => `Update ${action}`,
  VIEW_ACTION: (action: string) => `View ${action}`,
  DELETE_ACTION: (action: string) => `Delete ${action}`,

  // Field Labels
  FILTERS: 'Filters',
  GSIS_CONFIGURATION: 'GSIS Configuration',
  SSS_CONFIGURATION: 'SSS Configuration',
  BENEFIT: 'Benefit',
  CONTRIBUTION_TYPE: 'Contribution Type',
  HOLIDAY_RATE: 'Holiday Rate',
  OVERTIME_RATE: 'Overtime Rate',


  BLANK: '',
  CLASS_CODE: 'Class Code',
  CODE: 'Code',
  DESCRIPTION: 'Description',
  FREQUENCY: 'Frequency',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  SEMI_MONTHLY: 'Semi-Monthly',
  QUARTERLY: 'Quarterly',
  ANNUAL: 'Annual',
  ADJUSTMENT_BEFORE_TAXABLE: 'Adjustment Before Taxable',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  MINIMUM_MONTHLY_SALARY: 'Minimum Monthly Salary',
  MAXIMUM_MONTHLY_SALARY: 'Maximum Monthly Salary',
  MINIMUM_TAXABLE_SALARY: 'Minimum Taxable Salary',
  MAXIMUM_TAXABLE_SALARY: 'Maximum Taxable Salary',
  MONTHLY_SALARY_CREDIT: 'Monthly Salary Credit',
  GSIS_EMPLOYEE_SHARE: 'GSIS Employee Share',
  GSIS_EMPLOYER_SHARE: 'GSIS Employer Share',

  EMPLOYEE_SHARE: 'Employee Share',
  EMPLOYER_SHARE: 'Employer Share',

  WITHHOLDING_TAX: 'Withholding Tax',
  HOLIDAYS: 'Holidays',
  SSS: 'SSS Configurations',
  PHILHEALTH: 'PhilHealth Configuration',
  PAGIBIG: 'Pag-IBIG Configuration',
  OVERTIME_RATES: 'Overtime Rates',
  NIGHT_DIFFERENTIAL: 'Night Differential Configuration',
  HOLIDAY_RATES: 'Holiday Rates',
  BENEFITS: 'Benefits',
  MAINTENANCE: 'Maintenance',
  REPORT: 'Report',

  FIX_TAX_AMOUNT: 'Fix Tax Amount',
  EXEMPT_AMT: 'Exempt Amount',
  PERCENT_OVER_EXEMPT_AMT: '% Over Exempt Amount',

  ALLOWANCE: 'Allowance',
  AMOUNT: 'Amount',
  HOURLY_RATE: 'Hourly Rate',

  START_TIME: 'Start Time',
  END_TIME: 'End Time',

  CTPA: 'CTPA',
  CTPA_CONFIGURATION: 'CTPA Configuration',

  DEDUCTION: 'Deduction',
  GOVT_IDS: 'Government IDs',
  ANNUAL_TAX: 'Annual Tax',
  DAILY_RATE: 'Daily Rate',
  REST_DAY_RATE: 'Rest Day Rate',
  CLASSIFICATION: 'Classification',
  STATUS: 'Status',
  EMPLOYEE_BANK_DETAIL: 'Employee Bank Detail',
  BANK_DETAILS: 'Bank Details',
  LOAN_INTERESTS: 'Loan Interests',
  LOAN_DETAILS: 'Loan Details',
  SEQUENCE: 'Sequence',
  BANK_NAME: 'Bank Name',
  SALARY_DETAILS: 'Salary Details',
  SOURCE: 'Source',
  EFFECTIVITY_DATE: 'Effectivity Date',
  SALARY: 'Basic Monthly Salary',
  BANK_ACCOUNT_NUMBER: 'Bank Account Number',
  RATE: 'Rate',
  PREMIUM_RATE: 'Premium Rate',

  EMPLOYEE_PAYROLL: 'Employee Payroll',
  EMPLOYEE: 'Employee',
  LISTING: 'Listing',
  EMPLOYEE_ID: 'Employee ID',
  EMPLOYEE_FULL_NAME: 'Employee Name',
  EMPLOYEE_NUMBER: 'Employee Number',
  SUPERVISOR_NAME: 'Supervisor',
  DEPARTMENT: 'Department',
  POSITION: 'Position',
  POSITION_LEVEL: 'Position Level',
  HIRING_DATE: 'Hiring Date',
  EMPLOYEE_STATUS: 'Employee Status',

  NAME: 'Name',
  INSTALLMENT_AMT: 'Installment Amount',
  INTEREST_AMT: 'Interest Amount',
  NUMBER_OF_INSTALLMENTS: 'Number of Installments',
  TYPE: 'Type',
  ADDITIONS: 'Additions',
  BACK: 'Back',
  PERCENT: 'Percent',
  MINUTE_RATE: 'Minute Rate',
  KEYCLOAK_ID: 'Keycloak ID',
  PAGIBIG_SALARY_CAP: 'Pag-IBIG Salary Cap',
  MAXIMUM_FUND_SALARY: 'Maximum Fund Salary',

  HOLIDAY_TITLE: 'Title',
  HOLIDAY_DATE: 'Date',
  RATE_CODE: 'Code',
  ALLOW_WORK_ON_HOLIDAY: 'Allow Work on Holiday',
  REGULAR_HOLIDAY: 'Regular Holiday',
  HOLIDAY_PAY_SCHEDULE: 'Holiday Pay Schedule',
  EMPLOYER_EC_CONTRIBUTION: 'Employer EC Contribution',
  IN_PERCENTAGE_ABSOLUTE: 'In Percentage/Absolute',
  PROVIDENT_FUND_CONTRIBUTION: 'Provident Fund Contribution',

  DATE_HIRED: 'Date Hired',
  PAYROLL_SCHEDULE: 'Payroll Schedule',
  PAYROLL_SCHEDULE_CALENDAR: 'Payroll Schedule Calendar',
  EVENTS: 'Events',
  TODAY: 'Today',
  EVENT: 'Event/s',

  TITLE: 'Title',
  SCHEDULE_TYPE: 'Schedule Type',
  RECURRENCE_RULE: 'Recurrence Rule',
  INTERVAL: 'Interval',
  DAY_OF_MONTH: 'Day of Month',
  WEEK_OF_MONTH: 'Week of Month',
  DAY_OF_WEEK: 'Day of Week',
  MONTH_OF_YEAR: 'Month of Year',
  SINGLE: 'Single Day Event',
  RANGE: 'Date Range',
  RECURRING: 'Recurring Schedule',
  DATE: 'Date',

  PAYROLL_REVIEW_AND_APPROVAL: 'Payroll Review & Approval',
  PAYROLL_PROCESSING: 'Payroll Processing',

  REFERENCE_NO: 'Reference #',
  COMPENSATION_TYPE: 'Compensation Type',
  PAYSLIP_NAME: 'Payslip Name',
  DATE_FROM: 'Date From',
  DATE_TO: 'Date To',
  PAYOUT_DATE: 'Payout Date',

  ENTER_PAYROLL: 'Enter Payroll',
  PREVIEW_PAYROLL: 'Preview Payroll',
  PAYROLL_APPROVAL: 'Payroll Approval',
  POSTED: 'Posted',

  EMPLOYEE_NAME: 'Employee Name',
  JOB_TITLE_POSITION: 'Job Title/Position',
  DEPARTMENT_GROUP: 'Department/Group',
  GROSS_PAY: 'Gross Pay',
  WORK_HOURS: 'Work Hours',
  NET_PAY: 'Net Pay',

  GROSS_BASIC_SALARY: 'Gross Basic Salary',
  OVERTIME: 'Overtime',
  BENEFIT_COMMISSIONS: 'Benefit - Commissions',
  SSS_CONTRIBUTION: 'SSS Contribution',
  SSS_PROVIDENT_FUND: 'SSS Provident Fund',
  PAGIBIG_HMDF: 'PAG-Ibig / HMDF',
  OTHER_DEDUCTIONS: 'Other Deductions',
  LOANS_LOAN_INTEREST: 'Loans/Loan Interest',
  TAXABLE_INCOME: 'Taxable Income',
  GRAND_TOTAL: 'Grand Total',
  PAY_PERIOD: 'Pay Period',
  DEDUCTIONS: 'Deductions',
  TAXES: 'Taxes',
  PAYROLL_BATCH: 'Payroll Batch',
  EMPLOYEE_BATCH: 'Employee Batch',
  PAYSLIP_STATUS: 'Payslip Status',
  SALARY_COMPUTATION: 'Salary Computation',
  EMPLOYEE_GOVERNMENT_CONTRIBUTIONS: 'Employee Government Contributions',

  REGULAR_DAY: 'Regular Day',
  REST_DAY: 'Rest Day',
  HOLIDAY: 'Holiday',
  ABSENCES: 'Absences',
  LEAVES: 'Leaves',

  HOURS_MINUTES: 'Hours/Minutes',
  DATE_OF_ABSENT: 'Date of Absent',
  LEAVE_TYPE: 'Leave Type',
  REQUEST_TYPE: 'Request Type',
  REASON: 'Reason',
  PAY_PERIOD_FROM: 'Pay Period From',
  PAY_PERIOD_TO: 'Pay Period To',

  REGULAR_PAY: 'Regular Pay',
  THIRTEENTH_MONTH_PAY: '13th Month Pay',

  SALARY_NAME: 'Salary Name',
  TOTAL: 'Total',

  LATE: 'Late',
  UNDERTIME: 'Undertime',
  ABSENT: 'Absent',
  TAXABLE: 'Taxable',
  NON_TAXABLE: 'Non-Taxable',

  PAYOUT_DATE_1: 'Payout Date 1',
  PAYOUT_DATE_2: 'Payout Date 2',
  JOB_LEVEL: 'Job Level'

}

export const PAYROLL_LINE_ITEM_KEYS: Record<string, string> = {
  ['sssEmployeeContribution']: 'SSS Employee Contribution',
  ['sssMandatoryProvidentFund']: 'PhilHealth Provident Fund',
  ['philhealthEmployeeContribution']: 'PhilHealth Employee Contribution',
  ['pagibigContribution']: 'PAG-Ibig Contribution',
  ['gsisContribution']: 'GSIS Contribution',
  ['otherContributions']: 'Other Contributions',


}